import { ActionReducer, Action } from '@ngrx/store';
import { initialPyramidalShareholderListState, IPyramidalShareholderListState } from '../states/pyramidal-shareholder-list.state';
import { EPyramidalShareholderListActions, SetSearchFilter, SetPagination, SetSort } from '../actions/pyramidal-shareholder-list.actions';

export const pyramidalShareholderListReducers: ActionReducer<IPyramidalShareholderListState, Action<string>> = (
  state = initialPyramidalShareholderListState,
  action: Action<string>
) => {
  switch (action.type) {
    case EPyramidalShareholderListActions.SetSearchFilter: {
      const typedAction = action as SetSearchFilter;
      return {
        ...state,
        searchFilter: typedAction.payload,
        currentPage: 1 // Reset to first page when search changes
      };
    }

    case EPyramidalShareholderListActions.SetPagination: {
      const typedAction = action as SetPagination;
      return {
        ...state,
        currentPage: typedAction.payload.currentPage,
        pageSize: typedAction.payload.pageSize
      };
    }

    case EPyramidalShareholderListActions.SetSort: {
      const typedAction = action as SetSort;
      return {
        ...state,
        sortBy: typedAction.payload.sortBy,
        ascending: typedAction.payload.ascending
      };
    }

    case EPyramidalShareholderListActions.ClearFilters: {
      return {
        ...initialPyramidalShareholderListState
      };
    }

    default:
      return state;
  }
};
